/**
 * @fileoverview Agent definition for image-editor-fal-v2.
 *
 * This agent edits existing images using FAL edit models, accepting a source
 * image and editing instructions to produce a modified version.
 *
 * @category visuals.images.edit
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'image-editor-fal-v2',
  kind: 'primitive',
  name: 'Image Editor (FAL)',
  description: 'Edits existing images using FAL edit models with user-provided editing instructions.',
  category: 'visuals',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-04',
    lastUpdated: '2026-04',
    taxonomyPath: 'visuals.images.edit',
    usedBy: [
      'use-image-editor-fal-v2.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'reference-image-creator-fal-v2',
      'story-image-creator-fal-v2',
    ],
  },
};
